module.exports = new __parcel__URL__("logo.2197766c.svg").toString();